// vendor
import Vue from 'vue'
// import _findIndex from 'lodash/findIndex';
// import _find from 'lodash/find';

const setCondition = (state, payload) => {
  state.conditions.push(payload);
};

const changeConditionState = (state, payload) => {
  // console.log(4, 'mutation condition', payload);

  if (payload.condition.composite) {
    Vue.set(state.conditions, payload.idx, payload.condition);
  } else if (payload.condition.multiple) {

  } else {
    Vue.set(state.conditions, payload.idx, payload.condition);
  }

  // if (condition.multiple) {
  //   const name = payload.value[0].name;
  //   if (condition.type === 'OR') {
  //     for (let i = 0; i < payload.value.length; i++) {
  //       // console.log(condition[name], payload.value[i].value);
  //       // if (condition[name].includes(payload.value[i])) {
  //       let find = _find(condition[name], (o) => {
  //         return o[name] === payload.value[i].value;
  //       });
  //
  //       if (find) {
  //         console.log('WHAAA', condition[name], payload.value[i].value);
  //         status = true;
  //         break;
  //       }
  //     }
  //   }
  // } else {
  //   status = condition[payload.name] === payload.value;
  // }
  // console.log(4.1, 'mutation condition', status);
};

export default {
  setCondition,
  changeConditionState
}
